import { useMutation, useQueryClient } from "@tanstack/vue-query";
import { ApiResponse } from "@/utils/ApiResponse";
import { useToast } from "vue-toastification";
import { DeletePedidoAction } from "../actions";
import { gpedPedidoInterface } from "../interfaces/gpedPedido.inteface";

export function usePedidoDelete(onClose?: () => void) {
  const toast = useToast();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (pedidoId: string) =>
      DeletePedidoAction(pedidoId),
    onSuccess: async (_response: ApiResponse<gpedPedidoInterface>) => {
      await queryClient.invalidateQueries({
        queryKey: ["gpedListPedidos"],
      });
      toast.success("El pedido fue eliminado correctamente");
      if (onClose) onClose();
    },
    onError: () => {
      toast.error("Error al eliminar el pedido");
    },
  });
  return {
    ...mutation, // => { mutate, mutateAsync, isPending, isError, error, isSuccess, data }
  };
}
